module.exports = __webpack_public_path__ + "static/media/doc-download.ed33d81f.svg";